import React from 'react';

import ModalBulkTaskType from "./bulk-action/update-task-type/task-type"
import ModalProjectConvertNew from "./project/convert/project-convert-new"
import projectConvert_checkPageAndConfirm from "./project/convert/functions/check-and-confirm-page-convert";
import {modalMoveMulti} from "./move-to/move"

class BulkModalsManager {

    constructor() {}

    updateTimeAllocation(callback) {
        gd.modal.showForm({
            header: {
                title: 'Update Time Allocation'
            },
            component: require('./bulk-action/update-time-allocation/update-time-allocation'),
            params: {
                onSubmit: result=>{
                    if (callback) callback(result);
                    else gd.modal.hide();
                }
            }
        });
    }

    move(projects, tasks, onMoveCallback) {
        return modalMoveMulti(projects, tasks, {
            callback: onMoveCallback,
        })
    }

    addTag(companyId, arrTasks, existingTags, callback) {
        gd.modal.showV4({
            className: 'modal-tag',
            header: {
                title: 'Select Tag'
            },
            component: require('./tag/modal-tag'),
            params: {
                tasks       : arrTasks,
                companyId   : companyId,
                tags        : existingTags ? existingTags : [],
                callback    : callback
            }
        });
    }

    removeTag(companyId, arrTasks, existingTags, callback) {
        gd.modal.showV4({
            className: 'modal-tag',
            header: {
                title: 'Remove Tag'
            },
            component: require('./tag/modal-tag'),
            params: {
                tasks       : arrTasks,
                companyId   : companyId,
                tags        : existingTags ? existingTags : [],
                removeOnly  : true,
                callback    : callback
            }
        });
    }

    schedule(buttons, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Schedule',
            },

            component: require('./select-date/select-date'),

            params: {
                onSubmit: (date, status)=>{
                    if (callback) callback(date, status);
                    gd.modal.hide();
                },
                this            : this,
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnSomeday      : buttons.someday,
                btnNoValue      : buttons.noValue,
                btnNoValueLabel : 'No schedule'
            }
        });
    }

    addCRMContacts(accountId, contactIds, callback) {
        gd.modal.showV4({
            className: 'modal-crm-search',
            component: require('./crm/search/search'),
            params: {
                type    : 'contact',
                accountId,  // for 'contact' type
                contactIds, // for 'contact' or 'remove-contact' type
                onSubmit: (crmAccountId, crmContactIds)=>{
                    if (callback) callback(crmContactIds);
                    gd.modal.hide();
                },
            }
        })
    }

    removeCRMContacts(contactIds, callback) {
        gd.modal.showV4({
            className: 'modal-crm-search',
            component: require('./crm/search/search'),
            params: {
                type    : 'remove-contact',
                contactIds, // for 'contact' or 'remove-contact' type
                onSubmit: (crmAccountId, crmContactIds)=>{
                    if (callback) callback(crmContactIds);
                    gd.modal.hide();
                },
            }
        })
    }

    updateActionRequired(companyId, projectId, onSubmit) {
        gd.modal.showForm({
            header: {
                title: 'Action Required by'
            },
            component: require('./bulk-action/update-action-required/action-required.jsx'),
            params: {
                noValueLabel: "No Action required",
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId
            }
        });
    }

    updateAssigned(companyId, projectId, onSubmit) {

        gd.modal.showForm({
            header: {
                title: 'Assign to'
            },
            component: require('./bulk-action/update-action-required/action-required.jsx'),
            params: {
                noValueLabel: "Not Assigned",
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId
            }
        });
    }

    // manager -> app.manager
    updateTaskType(projectId, manager, onSubmit) {

        gd.modal.showForm({
            className: 'modal-bulk-task-type',
            header: {
                title: 'Select Task Type'
            },
            component: ModalBulkTaskType,

            params: {
                onSubmit: onSubmit,
                // companyId: gd.companyId,
                projectId: projectId, // not in use at the moment
                manager: manager,
            }
        });

    }

    async updateProjectType(projectIds, onConvertCallback) {
        const result = await projectConvert_checkPageAndConfirm(projectIds)

        if (result) {
            gd.modal.showV4({
                className   : 'modal-project-convert',
                component   : ModalProjectConvertNew,
                params      : {
                    projectIds  : projectIds,
                    callback(values) {
                        gd.modal.hide()
                        if (onConvertCallback) onConvertCallback(values)
                    }
                }
            })
        }
    }

    updatePriority(companyId, projectId, manager, onSubmit) {

        gd.modal.showForm({
            className: 'modal-bulk-priority',
            header: {
                title: 'Select Priority'
            },
            component: require('./bulk-action/update-priority/update-priority.jsx'),

            params: {
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId,
                manager: manager,
            }
        });

    }

    updateStatus(companyId, projectId, itemsGroupedByType, onSubmit) {

        gd.modal.showForm({
            className: 'modal-bulk-status',
            header: {
                title: 'Update Status'
            },
            component: require('./bulk-action/update-status/update-status.jsx'),

            params: {
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId,
                itemsGroupedByType: itemsGroupedByType,
            }
        });

    }

    updateDeadline(buttons, onSubmit) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks Deadline'
            },
            component: require('./deadline-task/modal-action-deadline'),

            params: {
                onSubmit,
                btnUnset: buttons.unset,
            }
        });
    }

    updateStartDate(buttons, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks start Date',
            },

            component: require('./select-date/select-date'),

            params: {
                onSubmit: value=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateEndDate(buttons, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks end Date',
            },

            component: require('./select-date/select-date'),

            params: {
                onSubmit: value=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateStartEndDate(buttons, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-date-range',
            header: {
                title: 'Start/End Date',
            },

            component: require('./select-date/select-date-range'),

            params: {
                onSubmit: value=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateDate(title, callback) {
        gd.modal.showGeneric({
            // className: 'modal-action-deadline',
            header: {
                title,
            },

            component: require('./select-date/select-date'),

            params: {
                onSubmit: value=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
            }
        });
    }

    updateEstimate(callback) {
        gd.modal.showGeneric({
            className: 'modal-action-estimate',
            header: {
                title: 'Tasks Estimate'
            },
            component: require('./estimate-task/modal-action-estimate'),
            params: {
                onSubmit: values=>{
                    const estimate = values.hours * 60 + values.minutes;
                    if (callback) callback(estimate);
                    gd.modal.hide();
                },
            }
        });
    }

    updateStoryPoints(callback) {
        gd.modal.showGeneric({
            className: 'modal-action-story-points',
            header: {
                title: 'Tasks Story points'
            },
            component: require('./story-points/modal-action-story-points'),
            params: {
                onSubmit: storyPoints=>{
                    if (callback) callback(storyPoints);
                    gd.modal.hide();
                },
            }
        });
    }

    updateProgress(callback) {
        gd.modal.showGeneric({
            className: 'modal-progress',
            component: require('./progress/progress'),
            header: {
                title: 'Tasks Progress'
            },
            params: {
                onSubmit: value=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                }
            }
        });
    }

    updateCustomField(customFieldId, callback, options={}) {
        gd.modal.showForm({
            header: {
                title: 'Update'
            },
            component: require('./bulk-action/update-custom-field/update-custom-field.jsx'),
            params: {
                onSubmit: (newValue)=>{
                    if (callback) callback(newValue);
                    else gd.modal.hide();
                },
                customFieldId: customFieldId
            }
        });
    }

    deleteTasks(tasks, callback) {


        const message = (
            <div>
                <div className="message">
                    <div className="txt">
                        Are you sure that you want to delete selected tasks?
                    </div>
                </div>
                <div className="comment">
                    All tasks data, attachments, subtasks and time reports will be deleted as well.
                </div>
            </div>
        );

        gd.modals.confirm.deleteMessage('Tasks',message,()=>{

            if (callback) callback({deleteInProgress: true});

            const request = gd.api.BulkActions.deleteTasks(tasks);
            request.done(response=>{
                gd.session.recent.tasks.tasksRemove(response);
                gd.modal.hide();
                if (callback) callback(response);
            });
        });
    }
}

module.exports = BulkModalsManager;